<template>
  <div class="examSetting">
    <div style="float: left; font-size: 13px">
      考试课程：{{ examData.subjectCourse.name }}
    </div>
    <div
      style="float: right; font-size: 13px"
      class="examSetting-color"
      v-if="examTime != '已结束'"
      @click="signTimeDialogVisibleTrue"
    >
      距离报名结束时间：{{ examTime }}
    </div>
    <div
      style="float: right; font-size: 13px"
      class="examSetting-color"
      v-if="examTime == '已结束'"
    >
      <!-- @click="signTimeDialogVisibleTrue" -->
      报名{{ examTime }}
    </div>
    <div class="examSetting-center">
      <div>
        <div style="font-size: 16px; margin-left: 30px">
          {{ examData.subjectCourse.name }}第{{ examData.sequence }}期
        </div>

        <div class="examSetting-item">
          考试时间
          <el-button
            class="examSetting-left"
            size="small"
            @click="timeDialogVisibleTrue"
            >&nbsp;&nbsp;设置时间&nbsp;&nbsp;</el-button
          >
          <span class="examSetting-left examSetting-color"
            >{{ examData.examBeginTime }}-{{
              examData.examEndTime.split(' ')[1]
            }}</span
          >
        </div>
        <div class="examSetting-item">
          报名时间
          <el-button
            class="examSetting-left"
            size="small"
            @click="signTimeDialogVisibleTrue"
            >&nbsp;&nbsp;设置时间&nbsp;&nbsp;</el-button
          >
          <span class="examSetting-left examSetting-color"
            >{{ examData.signBeginTime }}-{{
              examData.signEndTime.split(' ')[1]
            }}</span
          >
        </div>
        <div style="display: flex">
          <div class="examSetting-item">
            模拟试卷
            <el-button
              class="examSetting-left"
              :type="examData.examState == 1 ? 'primary' : 'info'"
              size="small"
              @click="openExamDialogVisible()"
              >&nbsp;&nbsp;设置试卷&nbsp;&nbsp;</el-button
            >
          </div>
          <div
            v-for="(item, index) in examData.examSettingRelationList"
            :key="index"
            class="examSetting-exam"
          >
            <div v-if="index == 0 && item.exam != null">
              {{ item.exam.name }}
            </div>
            <div v-if="index == 1 && item.exam != null">
              {{ item.exam.name }}
            </div>
          </div>
        </div>
        <div style="display: flex" v-if="isShow == 1">
          <div class="examSetting-item" v-show="isUpdate == 1">
            审批人&nbsp;&nbsp;&nbsp;&nbsp;
            <el-button
              class="examSetting-left"
              :type="isUpdate == 1 ? 'primary' : 'info'"
              size="small"
              @click="openExamSettingTeacherList()"
              >设置审批人</el-button
            >
          </div>
          <div class="examSetting-exam-text" v-if="teacherList.length == 0">
            该试卷中包含非客观题，需要添加试卷审批人，考生提交试卷后审批人可到
            “考试结果 >试卷审批” 中审批
          </div>
          <div class="examSetting-exam-teacher" v-if="teacherList.length > 0">
            <span
              v-for="(item, index) in teacherList"
              :key="index"
              style="margin-left: 10px"
              >{{ item }}</span
            >
          </div>
        </div>
      </div>
      <el-dialog :visible.sync="timeDialogVisible" width="400px">
        <el-form
          :model="periodForm"
          status-icon
          ref="periodForm"
          :rules="periodFormRules"
          label-width="80px"
        >
          <el-form-item label="考试日期" prop="date">
            <el-date-picker
              :picker-options="pickerOptions"
              style="width: 100%"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              v-model="periodForm.date"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="考试时间" prop="endTime">
            <el-row>
              <el-col :span="11">
                <el-time-select
                  style="width: 100%"
                  placeholder="起始时间"
                  v-model="periodForm.beginTime"
                  :picker-options="{
                    start: '06:00',
                    step: '00:15',
                    end: '24:00',
                  }"
                ></el-time-select>
              </el-col>
              <el-col :span="2">
                <div class="time-selectType">至</div>
              </el-col>
              <el-col :span="11">
                <el-time-select
                  style="width: 100%"
                  placeholder="结束时间"
                  v-model="periodForm.endTime"
                  :picker-options="{
                    start: '06:00',
                    step: '00:15',
                    end: '24:00',
                    minTime: periodForm.beginTime,
                  }"
                ></el-time-select>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="timeDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="addSchedulePeriod">提交</el-button>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="signTimeDialogVisible" width="500px">
        <el-form
          :model="signForm"
          status-icon
          ref="signForm"
          :rules="signFormRules"
          label-width="80px"
        >
          <el-form-item label="报名日期" prop="date">
            <el-date-picker
              style="width: 100%"
              arrow-control
              v-model="signForm.date"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="signTimeDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="addSignSchedulePeriod"
            >提交</el-button
          >
        </div>
      </el-dialog>
    </div>

    <el-dialog title="选择试卷" :visible.sync="examDialogVisible" width="50%">
      <div class="testPaperManageDetail">
        <div class="testPaperManageDetail01">
          <el-table
            ref="examListTable"
            :data="examList"
            tooltip-effect="dark"
            @select="examListSelect"
            @select-all="examListSelectAll"
            @selection-change="examListSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              type="index"
              width="50"
              label="序号"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="name"
              label="默认考卷"
            ></el-table-column>
          </el-table>
        </div>
        <div class="testPaperManageDetail02">
          <el-table
            ref="examSettingListTable"
            :data="examSettingList"
            tooltip-effect="dark"
            @select="examSettingListSelect"
            @select-all="examSettingListSelectAll"
            @selection-change="examSettingListSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column
              type="index"
              width="50"
              label="序号"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              prop="name"
              label="自定义考卷"
            ></el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateExamSetting">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="设置审批人"
      :visible.sync="examSettingTeacherVisible"
      width="50%"
    >
      <div>
        <el-row :gutter="20" style="margin-bottom: 10px">
          <el-col :sm="12" :md="6" :lg="6">
            <el-cascader
              style="width: 100%"
              v-model="searchForm.campusId"
              :show-all-levels="false"
              :props="campusTreeProps"
              placeholder="请选择所属校区"
              :options="campusList"
              clearable
            ></el-cascader>
          </el-col>
          <el-col :sm="12" :md="6" :lg="6">
            <el-cascader
              style="width: 100%"
              clearable
              v-model="searchForm.goodAtSubjectId"
              :show-all-levels="false"
              :props="subjectTreeProp"
              placeholder="请选择所属科目"
              :options="subjectTreeList"
            ></el-cascader>
          </el-col>
          <el-col :sm="12" :md="6" :lg="6">
            <el-input
              v-model="searchForm.name"
              placeholder="搜索老师"
              clearable
            ></el-input>
          </el-col>
          <el-col :sm="12" :md="4" :lg="4" style="float: right">
            <el-button
              type="primary"
              style="float: right"
              icon="el-icon-search"
              @click="getExamSettingTeacherList()"
              >查询</el-button
            >
          </el-col>
        </el-row>
      </div>
      <el-table
        ref="multipleTable"
        :data="examSettingTeacherList"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="campusName"
          label="校区"
          width="200"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="name"
          label="老师"
          width="100"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="goodAtSubjectName"
          label="主讲科目"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="teacherScoreCount"
          label="当前待审批"
          width="100"
        ></el-table-column>
      </el-table>
      <el-button
        style="margin-top: 20px"
        type="primary"
        @click="updateExamSettingTeacher"
        >添加({{ selectTeacherList.length }})</el-button
      >
    </el-dialog>
  </div>
</template>
 
<script>
export default {
  data () {
    return {
      examSettingTeacherVisible: false,
      timeDialogVisible: false,
      signTimeDialogVisible: false,
      examDialogVisible: false,
      blockAddSchedulePeriod: false,
      loading: false,
      examSettingTeacherList: null,
      examSettingTeacherData: null,
      searchForm: {
        campusId: null,
        goodAtSubjectId: "",
        name: "",
      },
      isUpdate: null,
      selectTeacherList: [],
      teacherList: [],
      periodForm: {
        // period: [],
        date: "",
        beginTime: "",
        endTime: "",
      },
      signForm: {
        period: [],
        date: "",
      },
      examData: {
        examEndTime: "",
        subjectCourse: {
          name: "",
        },
      },

      campusList: [],
      campusTreeProps: {
        value: "id",
        label: "name",
        children: "children",
        // checkStrictly: true
      },
      isShow: null,
      subjectTreeList: [],
      subjectTreeProp: {
        value: "id",
        label: "name",
        children: "children",
        // checkStrictly: true
      },
      examDataTemp: {},
      examSettingList: [],
      examList: [],
      examTime: "",
      temp: null,
      examSelectionTrue: false,
      pickerOptions: {
        disabledDate (time) {
          var times = Date.now() - 24 * 60 * 60 * 1000;
          return time.getTime() < times;
        },
      },
      periodFormRules: {
        endTime: [
          {
            required: true,
            message: "请选择考试时间",
            trigger: "change",
          },
        ],
        date: [
          {
            required: true,
            message: "请选择考试日期",
            trigger: "change",
          },
        ],
      },
      signFormRules: {
        period: [
          {
            required: true,
            message: "请选择考试时间",
            trigger: "change",
          },
        ],
        date: [
          {
            required: true,
            message: "请选择考试日期",
            trigger: "change",
          },
        ],
      },
    };
  },
  destroyed () {
    clearInterval(this.temp);
  },
  methods: {
    getData () {
      this.examData = JSON.parse(localStorage.getItem("jump"));
      this.examDataTemp = JSON.parse(localStorage.getItem("jump"));
      this.getExamTime();
      this.api.examSettingTeacher
        .validExamSettingTeacherList({ examSettingId: this.examData.id })
        .then((result) => {
          if (result.message) {
            this.isUpdate = result.data.isUpdate;
            if (result.data.teacherList) {
              this.teacherList = result.data.teacherList;
            }
            if (result.data.isShow == 1) {
              this.isShow = true;
            }
          }
        });
    },
    signTimeDialogVisibleTrue () {
      // if (this.examData.examState > 1) {
      //   this.$message.warning("已超过考试时间");
      // } else {
      if (
        this.examData.signBeginTime != "" &&
        this.examData.signEndTime != ""
      ) {
        this.signForm.date = [
          this.examData.signBeginTime,
          this.examData.signEndTime,
        ];
      }
      this.signTimeDialogVisible = true;
      // }
    },
    timeDialogVisibleTrue () {
      // if (this.examData.examState > 1) {
      //   this.$message.warning("已超过考试时间");
      // } else {
      if (
        this.examData.examBeginTime != "" &&
        this.examData.examEndTime != ""
      ) {
        this.periodForm.date = this.examData.examBeginTime.split(" ")[0];
        this.periodForm.beginTime = this.examData.examBeginTime.split(" ")[1];
        this.periodForm.endTime = this.examData.examEndTime.split(" ")[1];
        // this.periodForm.period = [
        //   this.examData.examBeginTime.split(" ")[1],
        //   this.examData.examEndTime.split(" ")[1]
        // ];
      }
      this.timeDialogVisible = true;
      // }
    },
    getExamTime () {
      this.temp = setInterval(() => {
        this.$set(
          this,
          "examTime",
          this.countDownFun(
            new Date(this.examData.signEndTime.replace(/-/g, "/")).getTime()
          )
        );
      }, 1000);
    },
    openExamDialogVisible () {
      if (this.examData.examState > 1) {
        this.$message.warning("已超过考试时间");
      } else {
        this.getExamList();
        this.getExamSettingList();
        this.examDialogVisible = true;
      }
    },
    getExamList () {
      this.api.examSetting
        .getExamList({
          type: "全真模考",
          courseId: this.examData.courseId,
        })
        .then((result) => {
          if (result.success) {
            this.examList = result.data;
            for (let index in this.examList) {
              for (let item of this.examData.examSettingRelationList) {
                if (item.common == 1) {
                  if (item.exam.id == this.examList[index].id) {
                    this.$nextTick(() => {
                      this.$refs.examListTable.toggleRowSelection(
                        this.examList[index],
                        true
                      );
                    });
                  }
                }
              }
            }
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getExamSettingList () {
      this.api.examSetting
        .getExamList({
          type: "全真模考",
          courseId: this.examData.courseId,
          agentId: this.examData.agentId,
        })
        .then((result) => {
          if (result.success) {
            this.examSettingList = result.data;
            for (let index in this.examSettingList) {
              for (let item of this.examData.examSettingRelationList) {
                if (item.common == 2) {
                  if (item.exam.id == this.examSettingList[index].id) {
                    this.$nextTick(() => {
                      this.$refs.examSettingListTable.toggleRowSelection(
                        this.examSettingList[index],
                        true
                      );
                    });
                  }
                }
              }
            }
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addSchedulePeriod () {
      // this.blockAddSchedulePeriod
      if (this.blockAddSchedulePeriod) {
        return false;
      }
      this.$refs.periodForm.validate((valid) => {
        if (valid) {
          this.blockAddSchedulePeriod = true;
          this.examData.examBeginTime =
            this.periodForm.date + " " + this.periodForm.beginTime;
          this.examData.examEndTime =
            this.periodForm.date + " " + this.periodForm.endTime;
          this.api.examSetting
            .updateExamSetting(this.examData)
            .then((result) => {
              if (result.success) {
                this.timeDialogVisible = false;
                localStorage.setItem("jump", JSON.stringify(result.data));
                this.getData();
                this.blockAddSchedulePeriod = false;
              } else {
                this.$message.error(result.message);
                this.blockAddSchedulePeriod = false;
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    addSignSchedulePeriod () {
      this.$refs.signForm.validate((valid) => {
        if (valid) {
          this.examData.signBeginTime = this.signForm.date[0];
          this.examData.signEndTime = this.signForm.date[1];
          this.api.examSetting
            .updateExamSetting(this.examData)
            .then((result) => {
              if (result.success) {
                this.signTimeDialogVisible = false;
                localStorage.setItem("jump", JSON.stringify(result.data));
                this.getData();
              } else {
                this.examData = JSON.parse(localStorage.getItem("jump"));
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    updateExamSetting () {
      this.api.examSetting
        .updateExamSetting(this.examDataTemp)
        .then((result) => {
          if (result.success) {
            this.examDialogVisible = false;
            this.examDataTemp = result.data;
            localStorage.setItem("jump", JSON.stringify(result.data));
            this.getData();

            this.api.examSettingTeacher
              .validExamSettingTeacherList({ examSettingId: this.examData.id })
              .then((result) => {
                if (result.message) {
                  this.isShow = result.data.isShow;
                }
              });
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    examListSelect (selection, row) {
      if (selection.length > 1) {
        let del_row = selection.shift();
        this.$refs.examListTable.toggleRowSelection(del_row, false);
      }
    },
    examSettingListSelect (selection, row) {
      if (selection.length > 1) {
        let del_row = selection.shift();
        this.$refs.examSettingListTable.toggleRowSelection(del_row, false);
      }
    },
    examListSelectAll (selection) {
      if (selection.length > 1) {
        selection.length = 1;
      }
    },
    examSettingListSelectAll (selection) {
      if (selection.length > 1) {
        selection.length = 1;
      }
    },
    examListSelectionChange (val) {
      let obj = {
        examId: val[0].id,
        common: 1,
      };
      if (this.examDataTemp.examSettingRelationList == null) {
        this.examDataTemp.examSettingRelationList = [];
      }
      if (this.examDataTemp.examSettingRelationList.length > 0) {
        let length = this.examDataTemp.examSettingRelationList.length;
        this.examDataTemp.examSettingRelationList.splice(0, length);
        this.examDataTemp.examSettingRelationList.push(obj);
      } else {
        this.examDataTemp.examSettingRelationList.push(obj);
      }
      this.$refs.examSettingListTable.clearSelection();
    },
    examSettingListSelectionChange (val) {
      let obj = {
        examId: val[0].id,
        common: 2,
      };
      if (this.examDataTemp.examSettingRelationList == null) {
        this.examDataTemp.examSettingRelationList = [];
      }
      if (this.examDataTemp.examSettingRelationList.length > 0) {
        let length = this.examDataTemp.examSettingRelationList.length;
        this.examDataTemp.examSettingRelationList.splice(0, length);
        this.examDataTemp.examSettingRelationList.push(obj);
      } else {
        this.examDataTemp.examSettingRelationList.push(obj);
      }
      this.$refs.examListTable.clearSelection();
    },

    openExamSettingTeacherList () {
      if (this.isUpdate != 1) {
        this.$message.error("该场考试已开始，审批老师不可修改！")
        return;
      }
      this.api.examSettingTeacher
        .getExamSettingTeacherList({ examSettingId: this.examData.id })
        .then((result) => {
          if (result.success) {
            this.examSettingTeacherData = result.data;
          } else {
            this.$message.error(result.message);
          }
        });
      this.getExamSettingTeacherList();
      this.examSettingTeacherVisible = true;
      this.getCampusList();
      this.getSubjectTreeList();
    },
    updateExamSettingTeacher () {
      if (this.selectTeacherList.length == 0) {
        this.$message.error("请选择审批老师！");
        return;
      }
      let obj = [];
      this.teacherList = [];
      this.selectTeacherList.forEach((e) => {
        let temp = {
          examSettingId: this.examData.id,
          teacherId: e.id,
        };
        obj.push(temp);
        this.teacherList.push(e.name)
      });
      let tempApi = "addExamSettingTeacherBatch";
      if (this.examSettingTeacherData != null && this.examSettingTeacherData.length != 0) {
        tempApi = "updateExamSettingTeacherBatch";
      }
      this.loading = true;
      this.api.examSettingTeacher[tempApi](obj).then((result) => {
        if (result.success) {
          this.selectTeacherList = [];
          obj = [];
          this.examSettingTeacherVisible = false;
          this.$message.success(result.message);
          this.loading = false;
        } else {
          this.teacherList = [];
          this.$message.error(result.message);
          this.loading = false;
        }
      });
    },
    //设置审批人
    getExamSettingTeacherList () {
      if (this.searchForm.campusId != null) {
        if (typeof this.searchForm.campusId == "object") {
          let len = this.searchForm.campusId.length;
          this.searchForm.campusId = this.searchForm.campusId[len - 1];
        }
      }

      if (this.searchForm.goodAtSubjectId != null) {
        if (typeof this.searchForm.goodAtSubjectId == "object") {
          let len = this.searchForm.goodAtSubjectId.length;
          this.searchForm.goodAtSubjectId = this.searchForm.goodAtSubjectId[
            len - 1
          ];
        }
      }
      this.loading = true;
      this.api.agentUserInfo
        .getExamSettingTeacherList(this.searchForm)
        .then((result) => {
          if (result.success) {
            this.examSettingTeacherList = result.data;
            this.examSettingTeacherList.forEach((e, index) => {
              this.examSettingTeacherData.forEach((d) => {
                if (e.id == d.teacherId) {
                  this.$nextTick(() => {
                    this.$refs.multipleTable.toggleRowSelection(
                      this.examSettingTeacherList[index],
                      true
                    );
                  });
                }
              });
            });
            this.loading = false;
          } else {
            this.$message.error(result.message);
            this.loading = false;
          }
        });
    },

    handleSelectionChange (val) {
      this.selectTeacherList = val;
    },
    getCampusList () {
      this.api.campus
        .getCampusTree({ parentId: 1 })
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    if (itemss.children.length != 0) {
                      delete itemss.children;
                    } else {
                      delete itemss.children;
                    }
                  }
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          this.campusList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // 获取课程
    getSubjectTreeList () {
      this.api
        .getSubjectCourseTreeList()
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                delete items.children;
              }
            } else {
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  created () { },
  watch: {
    examDialogVisible: function (newVal) {
      if (!newVal) {
        this.getData();
      } else {
      }
    },
    timeDialogVisible: function (newVal) {
      if (!newVal) {
        // this.$refs.periodForm.resetFields();
        // this.periodForm = {};
        this.getData();
      } else {
      }
    },
  },
  mounted () {
    this.getData();
  },
};
</script>
<style scoped>
.examSetting {
  padding: 20px;
  background-color: #fff;
  min-height: calc(100% - 40px);
}
.examSetting-center {
  position: absolute;
  top: 45%;
  left: 45%;
}
.examSetting-item {
  font-size: 13px;
  margin-top: 20px;
}
.examSetting-left {
  margin-left: 20px;
}
.examSetting-color {
  color: #409eff;
  cursor: pointer;
}
.examSetting-exam {
  margin-top: 20px;
  color: #409eff;
  margin-left: 20px;
  line-height: 32.8px;
}
.examSetting-exam-teacher {
  margin-top: 20px;
  color: #409eff;
  margin-left: 10px;
  line-height: 32.8px;
  width: 350px;
  display: flex;
  flex-wrap: wrap;
}
.examSetting-exam-text {
  color: #a2aabc;
  width: 350px;
  margin-top: 20px;
  margin-left: 20px;
  line-height: 15px;
}
.time-selectType {
  text-align: center;
  width: 100%;
  line-height: 40px;
}
.testPaperManageDetail {
  display: flex;
  font-size: 13px;
}
.testPaperManageDetail01 {
  padding-left: 20px;
  margin-right: 20px;
  padding-bottom: 40px;
  background-color: #fff;
  width: 48%;
}
.testPaperManageDetail02 {
  padding-left: 20px;
  padding-bottom: 40px;
  background-color: #fff;
  min-height: calc(100% - 40px);
  width: 48%;
}
.testPaperManageDetail-type {
  border-left: 4px solid rgb(77, 148, 255);
  padding-left: 10px;
  font-weight: 600;
}
.testPaperManageDetail-box01 {
  display: flex;
  flex-wrap: wrap;
}
.testPaperManageDetail-box02 {
  position: relative;
  border: 1px solid rgb(238, 238, 238);
  height: 30px;
  width: 90%;
  font-size: 13px;
  margin-top: 20px;
  line-height: 32px;
  text-align: center;
}
.testPaperManageDetail-hover {
  position: absolute;
  top: 0px;
  right: 0px;
}
.testPaperManageDetail-icon {
  font-size: 16px;
  color: #4d94ff;
  margin-right: 10px;
  margin-left: 10px;
  cursor: pointer;
}
.testPaperManageDetail-box02:hover {
  color: rgb(77, 148, 255);
}
.testPaperManageDetail-index {
  line-height: 32px;
  margin-right: 20px;
  margin-top: 20px;
}
.testPaperManageDetail-button {
  width: 90%;
  margin-left: 27px;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/fullTruthModelTest/fullExamSetting.vue